import { Typography } from '@mui/material';
import React from 'react'
import { FlexInputLabel } from '../../optionalFeatures/widget/FearturesInputTypes/FeatureInputs';
import MustDoActionDataPointInput from "./mustDoActionDataPointInput/MustDoActionDataPointInput"
import {InputLengthValidations, SingleMustDoDataPointState} from '../types'
interface PropsState {
    actionId:string,
    description: string,
    datapoints: Array<SingleMustDoDataPointState>,
    onChange : (id:string , newDataPoints:Array<SingleMustDoDataPointState>) => void,
    inputLengthValidations : InputLengthValidations
}


function ActionEditor(props: PropsState) {
    const { description, datapoints , actionId  ,onChange,inputLengthValidations} = props;
    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        const val = e.target.value;
        
        // preview values utha update kar new wali send karde upar function me
        // with id
        const newValues = datapoints.map((datapoint)=>{
            let newDp = {...datapoint}
            if(datapoint.id == keyName){
                newDp = {
                    ...newDp,
                    value : val
                }
            } 
            return newDp;
        })

        if(onChange){
            return onChange(actionId , newValues);
        }
    }
    return (
        <div style = {{padding:"20px" , background:"#FFFFFF" , borderRadius: "0px 0px 8px 8px"}}>
            <Typography color={"#606060"}>
                {description}
            </Typography>
            <div style={{marginTop:"10px"}}>

            <div style={{gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", display:"grid"}} >
            {
                datapoints.filter((datapoint)=>datapoint.isEditable).map((datapoint) => {
                    return <MustDoActionDataPointInput
                        label={datapoint.label}
                        name={datapoint.id}
                        value={datapoint.value}
                        onChange={handleValueChange}
                        placeholder=""
                        datapoints = {datapoints}
                        inputLengthValidations = {inputLengthValidations}
                    />
                })
            }
            </div>
            </div>
        </div>
    )
}

export default ActionEditor